var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Paneles')
}
var staticRenderFns = []

export { render, staticRenderFns }